import React, { FC } from 'react'
import Tooltip from '../../Molecules/Tooltip/Tooltip'
import Icon from '../../Core/Iconography/Icon/Icon'
import Font from '../../Core/Typography/Font/Font'
import { LabelWrapper, RequiredMark, FlexWrapper } from './Label.styles'
import { LabelProps } from './types'

const Label: FC<LabelProps> = props => {
  const { label, tooltipLabel } = props

  if (!label) return null

  return (
    <LabelWrapper htmlFor={props.name} gridArea={props?.gridArea}>
      <FlexWrapper
        flexWrapperCentered={props.flexWrapperCentered}
        flexWrapperMinHeight={props.flexWrapperMinHeight}
        fontMarginTop={props.fontMarginTop}
        fontMarginBottom={props.fontMarginBottom}
      >
        <Font
          ellipsis={!props.removeEllipsis}
          tag={props.isHeading ? 'h4' : 'p'}
          bold={props.bold}
        >
          {label}
          {props.required && <RequiredMark>*</RequiredMark>}
        </Font>
        {tooltipLabel && (
          <Tooltip tooltipText={tooltipLabel} translateY={-6}>
            <Icon name='info' size='xs' color='ultraViolet' hoverColor />
          </Tooltip>
        )}
      </FlexWrapper>
    </LabelWrapper>
  )
}

Label.defaultProps = {
  name: '',
  tooltipLabel: '',
  required: false,
  isHeading: false,
  removeEllipsis: false
}

export default Label
